import { Component, OnInit, ViewEncapsulation, ChangeDetectorRef, ViewChild } from '@angular/core'; // Added ViewChild
import { Auth, signOut, User } from '@angular/fire/auth'; // Updated Auth
import { Router } from '@angular/router';
import { Functions, httpsCallable, HttpsCallableResult } from '@angular/fire/functions'; // Updated Functions
import { environment } from 'src/environments/environment';
import { Config } from 'src/app/_models/config';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { SharedService } from 'src/app/services/shared.service';
import { Menu } from 'primeng/menu';

@Component({
  selector: 'app-home-layout',
  templateUrl: './home-layout.component.html',
  styleUrls: ['./home-layout.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HomeLayoutComponent implements OnInit {

    public user: User | null = null; // Typed user
    public role: string;
    public config: Config;
    public downloadURL : string | undefined; // Changed type from Observable<string>
    public environment;
    public accountMenuItems: any[]; // Renamed property

    @ViewChild('accountMenu') menu: Menu;

    constructor(private router:Router,
          public auth: Auth, // Updated injection
          private functions: Functions, // Updated injection
          private myanalytics: AnalyticsService,
          private sharedService: SharedService) { // Added ChangeDetectorRef
      this.environment = environment;
      this.sharedService.role$.subscribe(role =>{
        this.role = role
      })
    }

    ngOnInit() {
        this.accountMenuItems = [ // Use renamed property
            {
                label: 'Sign-out',
                icon: 'pi pi-sign-out',
                command: () => this.signOut()
            }
        ];
    }

    public setRole(user: User, role: string) { // Typed user parameter
      // Define types for request and response
      type SetRoleRequest = { role: string; uid: string };
      type SetRoleResponse = { success: boolean; message?: string };

      const setRoleCallable = httpsCallable<SetRoleRequest, SetRoleResponse>(this.functions, 'setRole'); // Use modular httpsCallable
      let request: SetRoleRequest = {
        role: role,
        uid: user.uid
      };

      setRoleCallable(request)
        .then((response: HttpsCallableResult<SetRoleResponse>) => { // Use .then()
          const responseData = response.data;
          if (!responseData.success) {
            console.error(responseData.message || 'Set role failed');
            return;
          }
          // Role setting successful on backend.
          // Frontend role update might rely on token refresh or shared service update.
          // Forcing a token refresh might be needed to see claims immediately:
          // user.getIdToken(true);
          this.role = role; // Update local role state (might be overwritten by sharedService later)
          console.log(`Role set to ${role} for user ${user.uid}`);
          // Potentially update shared service if it holds the definitive role state
          // this.sharedService.updateUserRole(role);
        })
        .catch(error => { // Use .catch()
          console.error('Error calling setRole function:', error);
        });
    }

    public manageUser(event: Event) {
      // Removed user check - menu should toggle regardless of login state
      if (this.user) { // Log analytics only if user exists
          this.myanalytics.logEvent("button_click", {button: "ManageAccount", user: this.user.uid}); // Changed id to uid
      }
      event.preventDefault(); // Keep preventDefault for now, might be needed
      event.stopPropagation(); // Keep stopPropagation to prevent other handlers
      this.menu.toggle(event);
    }

    showAnalytics() {
      if (!this.user) return; // Add null check for user
      this.myanalytics.logEvent("button_click", {button: "GlobalAnalytics", user: this.user.uid}); // Changed id to uid
      let url = environment.combinedAnalytics;
      window.open(url, '_blank').focus();
    }

    public signOut() {
        signOut(this.auth).then(()=> { // Use modular signOut
            this.router.navigate(['/auth/sign-in']);
        }).catch(error => {
            console.error("Sign out error:", error);
            // Handle sign out error if necessary
        });
    }

    public openUrl(url) {
      if (!this.user) return; // Add null check for user
      this.myanalytics.logEvent("button_click", {button: "OpenUrl", user: this.user.uid, url: url}); // Changed id to uid
      window.open(url, '_blank').focus();
    }
}
